import type { Selected } from '~/features/epg/programs/select'

import { createEvent, sample } from 'effector'
import { selectEpgProgramModel } from '~/features/epg/programs/select'
import { nay } from '~/shared/helpers'

// load initial epg info
export const init = createEvent()

// reset widget on epg page left
export const left = createEvent()

// reset widget on sign out
export const reset = createEvent()

// probe program by clicking on it
export const probe = createEvent<Selected>()

// actually select program
export const select = selectEpgProgramModel.select

// allow to select program only when probing unlocked channel
sample({
  clock: probe,
  filter: ({ locked }) => nay(locked),
  target: selectEpgProgramModel.select,
})

//
// left and reset logic
//

// do nothing
// EPG data does not differs for different users, so,
// there is no need to remove loaded programs on left and/or reset
